import { useTranslation } from "react-i18next";

import { Group } from "#shared/view/components/Group";
import { Modal } from "#shared/view/components/Modal";
import { Space } from "#shared/view/components/Space";
import { Text } from "#shared/view/components/Text";
import { BasicTable } from "#shared/view/designSystem/BasicTable";
import { Button } from "#shared/view/designSystem/Button";
import { formatPrice, MaterialPriceAlert } from "shared";

type Props = {
  opened: boolean;
  close: () => void;
  alerts: MaterialPriceAlert[];
};

export const MaterialsPriceAlertModal = ({ opened, close, alerts }: Props) => {
  const { t } = useTranslation();

  const headers = [
    { id: "row", label: t("settings.materials.upload.priceAlertModal.columns.row") },
    {
      id: "materialGrade",
      label: t("settings.materials.upload.priceAlertModal.columns.materialGrade"),
    },
    { id: "format", label: t("settings.materials.upload.priceAlertModal.columns.format") },
    { id: "price", label: t("settings.materials.upload.priceAlertModal.columns.price") },
    { id: "minPrice", label: t("settings.materials.upload.priceAlertModal.columns.minPrice") },
  ];

  const elements = alerts.map((alert) => ({
    row: alert.row,
    materialGrade: t(`qrl.materialGrades.${alert.materialGrade}`),
    format: `${alert.length}x${alert.width}`,
    price: formatPrice(alert.price),
    minPrice: formatPrice(alert.minPrice),
  }));

  return (
    <Modal
      opened={opened}
      onClose={close}
      title={t("settings.materials.upload.priceAlertModal.title")}
      size="lg"
    >
      <Text>{t("settings.materials.upload.priceAlertModal.description")}</Text>

      <Space h="md" />

      <BasicTable headers={headers} elements={elements} />

      <Space h="md" />

      <Group justify="end">
        <Button onClick={close}>{t("common.close")}</Button>
      </Group>
    </Modal>
  );
};
